import { RootState } from "redux/rootReducer";

export const selectIsLoadingPatientCSV = (state: RootState) =>
  state.patientCSV.loading;
export const selectpatientCSVErrorMessage = (state: RootState) =>
  state.patientCSV.error;
export const patientCSVDataResponse = (state: RootState) =>
  state.patientCSV.patientCSVResponse;
